import React, { useEffect, useState } from 'react';

function DarkModeToggle() {
  const [darkMode, setDarkMode] = useState(false);
  const locationHost = window.location.host;

  if (locationHost.indexOf('freely') > -1) {
    useEffect(() => {
      const isDarkMode = localStorage.getItem('darkMode') === 'true';
      setDarkMode(isDarkMode);
    }, []);

    useEffect(() => {
      // @todo commented sections will need to go back in when client wants the toggle added in
      // document.documentElement.classList.toggle('fl-darkmode', darkMode);
      // localStorage.setItem('darkMode', darkMode);

      document.documentElement.classList.add('fl-darkmode', darkMode);
      localStorage.setItem('darkMode', darkMode);
    }, [darkMode]);
  }

  // const toggleDarkMode = () => {
  //   setDarkMode(prevMode => !prevMode);
  // };

  return (
    <>
      {/* <button type="button" className={`fl-button`} onClick={toggleDarkMode}>
        Toggle
      </button> */}
    </>
  );
}

export default DarkModeToggle;
